import React from 'react';
import AppComponent from './components/App/App';

function App() {
  return <AppComponent />;
}

export default App;
